import React, { useState } from "react";
import {
  Box,
  Container,
  Icon,
  IconButton,
  TextField,
  Typography,
  Snackbar,
  Alert,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { COMPANY_DATA } from "../../../../constants/placeholder";
import CTAButton from "../../../../components/buttons/CTAButton";
import SectionHeader from "../../../../components/typography/SectionHeader";

const Contact = () => {
  const [formData, setFormData] = useState({ email: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState({
    open: false,
    type: "",
    message: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email || !formData.message) {
      setFeedback({
        open: true,
        type: "error",
        message: "All fields are required!",
      });
      return;
    }

    setLoading(true);
    try {
      const response = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setFeedback({
          open: true,
          type: "success",
          message: "Message sent successfully!",
        });
        setFormData({ email: "", message: "" });
      } else {
        throw new Error("Failed to send message.");
      }
    } catch (error) {
      setFeedback({ open: true, type: "error", message: error.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Container>
        <Snackbar
          open={feedback.open}
          autoHideDuration={6000}
          onClose={() => setFeedback((prev) => ({ ...prev, open: false }))}
        >
          <Alert
            onClose={() => setFeedback((prev) => ({ ...prev, open: false }))}
            severity={feedback.type}
            sx={{ width: "100%" }}
          >
            {feedback.message}
          </Alert>
        </Snackbar>

        <Grid
          container
          spacing={2}
          py={3}
          sx={{
            flexDirection: { xs: "column-reverse", md: "row" },
            alignItems: "center",
          }}
        >
          <Grid size={{ xs: 12, md: 6 }}>
            <Box width={{ md: "90%" }}>
              <Box display="flex" flexDirection="column" rowGap={1}>
                <SectionHeader
                  tagline="CONTACT US"
                  title="Have questions or Need more information?"
                />
                <Box display="flex" columnGap={2}>
                  <Box display="flex" columnGap={2} justifyContent="center">
                    <Box display="flex" columnGap={1}>
                      <IconButton size="small" color="secondary">
                        <Icon fontSize="small">phone</Icon>
                        <Typography variant="body2" fontWeight={500}>
                          {COMPANY_DATA.phones[0]}
                        </Typography>
                      </IconButton>
                    </Box>
                    <Box
                      display="flex"
                      columnGap={1}
                      sx={{ display: { xs: "none", md: "flex" } }}
                    >
                      <IconButton size="small" color="secondary" sx={{ px: 0 }}>
                        <Icon fontSize="small">mail</Icon>
                        <Typography variant="body2" fontWeight={500}>
                          {COMPANY_DATA.emails[0]}
                        </Typography>
                      </IconButton>
                    </Box>
                  </Box>
                </Box>
                <Box
                  component="form"
                  noValidate
                  display="flex"
                  flexDirection="column"
                  onSubmit={(e) => {
                    e.preventDefault();
                    const subject = encodeURIComponent("Contact Us Inquiry");
                    const body = encodeURIComponent(formData.message);
                    const mailtoLink = `mailto:renphaconsulting@gmail.com?subject=${subject}&body=${body}`;
                    window.location.href = mailtoLink;
                    setFormData({ email: "", message: "" });
                  }}
                >
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="Email Address"
                    name="email"
                    autoComplete="email"
                    value={formData.email}
                    onChange={handleInputChange}
                  />
                  <TextField
                    margin="normal"
                    required
                    id="message"
                    label="Question/Message"
                    multiline
                    minRows={4}
                    placeholder="Enter your message or question"
                    fullWidth
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                  />
                  <Box display="flex" justifyContent="flex-end">
                    <CTAButton
                      type="submit"
                      text="Send"
                      fullWidth={false}
                      variant="outlined"
                      my={1}
                      disabled={loading}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid item size={{ xs: 12, md: 6 }} mb={4}>
            <Box
              display="flex"
              flexDirection="column"
              gap={2}
              justifyContent="center"
            >
              <div className="shadow-lg border-2 rounded-lg">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3963.935933215882!2d3.338251371924771!3d6.529776108666726!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x103b8dd41ef82c23%3A0xcb34f18c33fa5319!2s8%20Layi%20Oyekanmi%20St.%2C%20Mushin%2C%20Lagos%20102215%2C%20Lagos%2C%20Nigeria!5e0!3m2!1sen!2sgh!4v1736074292433!5m2!1sen!2sgh"
                  width="100%"
                  height="350"
                  // style="border:0;"
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>{" "}
              </div>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Contact;
